
var fitt = require('fitt'),
default_headers = {
	'Content-Type': 'application/x-www-form-urlencoded' };


function getDispatch(descriptor) {
	var dispatch;
	if (process.browser) {
		// For browsers use XHR
		dispatch = require('../dispatch/xhr.js');
	} else {
		// For node use HTTP or mock loader
		if (descriptor === 'mock') {
			dispatch = require('../dispatch/mock.js');
		} else {
			dispatch = require('../dispatch/http.js');
		}
	}
	return dispatch;
}

function transformJSON(data, headers) {
	var isJSON = headers && headers['content-type'] && /\bjson\b/.test(headers['content-type']);
	if (data && !fitt.isObj(data) && !fitt.empty(data) && isJSON) {
		return JSON.parse(data);
	}
	return data;
}

function transformHeaderData(data, headers) {
	if (headers && headers['Content-Type'] && /\bx-www-form-urlencoded\b/.test(headers['Content-Type'])) {
		var str = [],
		p;
		for (p in data) {
			if (data.hasOwnProperty(p) && data[p]) {
				str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
			}
		}
		return str.join("&");
	}
	return data;
}

if (typeof module !== fitt.TYPE_UNDEF) {
	module.exports = {

		getDispatch: getDispatch,

		headers: {
			'Accept': 'application/json, text/plain, */*' },


		method: 'GET',

		method_headers: {
			patch: default_headers,
			post: default_headers,
			put: default_headers },


		timeout: process.browser ? 10000 : 5000,

		tracing: false,

		transformRequest: [transformHeaderData],

		transformResponse: [transformJSON],

		validateResponse: function (response) {
			if (response.config.method === 'head') {
				return response.status === 404;
			} else {
				return response.status >= 200 && response.status < 300;
			}
		} };

}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/core/defaults.js
// module id = 605
// module chunks = 0